import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import {
  createNonExecution,
  createProcess,
  deleteProcess,
  editProcess,
  getAllProcess,
  getProcessById,
} from "./index";

export const useProcess = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getAllProcess: getAllProcess(customFetch),
      getProcessById: getProcessById(customFetch),
      createProcess: createProcess(customFetch),
      editProcess: editProcess(customFetch),
      deleteProcess: deleteProcess(customFetch),
      createNonExecution: createNonExecution(customFetch),
    }),
    [customFetch]
  );
};
